import React from 'react';
import { View } from '@gin-betting/core';
import cd from 'debug';

import { convertNameToRuLocale } from 'utils';

import './oddDetails.scss';

const debug = cd('app:betslip:components:OddDetails');

interface OwnProps {
    marketName: View.Market['name'];
    oddName: View.Odd['name'];
}

type Props = OwnProps;

const OddDetails: React.FC<Props> = ({ oddName, marketName }) => {
    debug('render');

    const convertedTitle = convertNameToRuLocale(oddName);

    return (
        <div styleName="container" className="__app-OddDetails-container">
            <div
                styleName="team"
                className="__app-OddDetails-team"
                title={convertedTitle}
            >
                <span>{convertedTitle}</span>
            </div>
            <div
                styleName="market"
                className="__app-OddDetails-market"
                title={marketName}
            >
                <span>{marketName}</span>
            </div>
        </div>
    );
};

export default OddDetails;
